import { render, staticRenderFns } from "./updateScenario.vue?vue&type=template&id=89900e2a&scoped=true&"
import script from "./updateScenario.vue?vue&type=script&lang=js&"
export * from "./updateScenario.vue?vue&type=script&lang=js&"
import style0 from "./updateScenario.vue?vue&type=style&index=0&id=89900e2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89900e2a",
  null
  
)

export default component.exports